import { render, staticRenderFns } from "./TemplatePageTable.vue?vue&type=template&id=5abd89f5"
import script from "./TemplatePageTable.vue?vue&type=script&lang=js"
export * from "./TemplatePageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports